import { render } from "./LinkArrowIcon.vue?vue&type=template&id=01814034"
const script = {}

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__